import { Box, Flex, Image, useDisclosure } from "@chakra-ui/react";
import Link from "next/link";
import { HelperLinks } from "./HelperLinks";
import { Profile } from './Profile';

export function Header() {

  const { isOpen: isOpenHelpers, onOpen: onOpenHelpers, onClose: onCloseHelpers } = useDisclosure();
  const { isOpen: isOpenAvatar, onOpen: onOpenAvatar, onClose: onCloseAvatar } = useDisclosure();

  return (
    <Box
      as="header"
      position="relative"
      zIndex="15"
      boxShadow="base"
      backgroundColor="#fff"
      color="gray.600"
      display="block"
      padding="0"
      margin="0"
    >
      <Flex alignItems="center" justifyContent="space-between" padding="9px 0">
        <Flex width="280px" padding="0 0 0 50px" alignItems="center">
          <Link href="/" passHref>
            <a>
              <Image src="/images/logo.png" alt="ENGYS" width="auto" height="44px" />
            </a>
          </Link>
        </Flex>
        <Flex marginRight="40px" alignItems="center" gap="10px">
          <HelperLinks isOpen={isOpenHelpers} onOpen={() => {
            onCloseAvatar();
            onOpenHelpers();
          }} onClose={onCloseHelpers} />
          <Profile isOpen={isOpenAvatar} onOpen={() => {
            onCloseHelpers();
            onOpenAvatar();
          }} onClose={onCloseAvatar} />
        </Flex>
      </Flex>
    </Box>
  )
}